import { Check } from 'lucide-react';

export type EnabledRepositoriesStatusProps = {
  title: string;
  description: string;
};

export const EnabledRepositoriesStatus = ({
  title,
  description,
}: EnabledRepositoriesStatusProps) => (
  <div className="flex items-center gap-3 p-4 rounded-sm bg-fill-interactive-neutral-idle">
    <Check className="size-4 stroke-icon-interactive-emphasis-idle" />
    <div className="flex flex-col gap-1">
      <p>{title}</p>
      <p className="text-sm text-text-bg-neutral-mild">{description}</p>
    </div>
  </div>
);
